import { actionSpinnerClose, actionSpinnerOpen } from '@qadra/frontend-common/redux/actions';
import { call, takeEvery, put } from '@qadra/frontend-common/redux-saga';
import { FORGOT, PASSWORD_RESET } from '../actions';
import { apiForgotPasswordPost, apiResetPasswordPost } from '../api';

function* passwordForgot({ payload }) {
  try {
    yield put(actionSpinnerOpen());

    const { emailSent, error } = yield call(apiForgotPasswordPost, payload);

    if (error) {
      yield put({
        type: FORGOT._ERROR,
        error,
      });
    } else {
      yield put({
        type: FORGOT._SUCCESS,
        emailSent,
      });
    }
    yield put(actionSpinnerClose());
  } catch (error) {
    yield put({
      type: FORGOT._ERROR,
      error,
    });
    yield put(actionSpinnerClose());
  }
}

function* watchPasswordForgot() {
  yield takeEvery(FORGOT._REQUEST, passwordForgot);
}

function* passwordReset({ payload }) {
  try {
    yield put(actionSpinnerOpen());

    const { passSent, error } = yield call(apiResetPasswordPost, payload);

    if (error) {
      yield put({
        type: PASSWORD_RESET._ERROR,
        error,
      });
    } else {
      yield put({
        type: PASSWORD_RESET._SUCCESS,
        passSent,
      });
    }
    yield put(actionSpinnerClose());
  } catch (error) {
    yield put({
      type: PASSWORD_RESET._ERROR,
      error,
    });
    yield put(actionSpinnerClose());
  }
}

function* watchPasswordReset() {
  yield takeEvery(PASSWORD_RESET._REQUEST, passwordReset);
}

const array = [watchPasswordForgot, watchPasswordReset];
export default array;
